module.exports = __webpack_public_path__ + "assets/img/PC1-2.ec2848d7.jpg";